import { IKnmReasonTypeExtended } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonTypeExtended';
import { IInspectionResult } from 'APIPackage/CatalogsModule/interfaces/IInspectionResult';

import { IKnmReasonTypeSelectOption } from '../interfaces/IKnmReasonTypeSelectOption';
import { IKnmReason } from '../../../APIPackage/KnmModule/interfaces/IKnmReason';
import { IKnmReasonType } from '../../../APIPackage/CatalogsModule/interfaces/IKnmReasonType';

export const createKnmReasonTypeSelectOption = (knmReasonType: IKnmReasonTypeExtended): IKnmReasonTypeSelectOption => ({
  ...knmReasonType,
  label: knmReasonType.name,
  value: knmReasonType.code,
});

export const createKnmConditionSelectOption = (
  knmReasonType: IKnmReasonTypeExtended,
  flagProfVizit?: boolean | null,
  inspectionResults?: IInspectionResult[],
): IKnmReasonTypeSelectOption => {
  let inspectionResult: IInspectionResult | undefined;

  if (inspectionResults) {
    inspectionResult = {
      inspectedField: inspectionResults[0].inspectedField,
      resultActionType: inspectionResults[0].resultActionType,
      inspectionMessage: inspectionResults.map(i => i.inspectionMessage).join(', '),
    };
  }

  return {
    ...knmReasonType,
    flagProfvizit: flagProfVizit || knmReasonType.flagProfvizit,
    label:
      knmReasonType.shortTitle ||
      knmReasonType.title ||
      `${knmReasonType.digitCode ? `${knmReasonType.digitCode} ` : ''}${knmReasonType.name}`,
    value: knmReasonType.code,
    title: knmReasonType.title,
    inspectionResult,
  };
};

export const createKnmReasonExtendedSelectOption = (
  reason: IKnmReason,
  knmReasonType: IKnmReasonType,
  flagProfVizit?: boolean | null,
  inspectionResults?: IInspectionResult[],
): IKnmReasonTypeSelectOption => {
  let inspectionResult: IInspectionResult | undefined;

  if (inspectionResults) {
    inspectionResult = {
      inspectedField: inspectionResults[0].inspectedField,
      resultActionType: inspectionResults[0].resultActionType,
      inspectionMessage: inspectionResults.map(i => i.inspectionMessage).join(', '),
    };
  }

  return {
    ...knmReasonType,
    flagProfvizit: flagProfVizit || knmReasonType.flagProfvizit,
    label:
      reason.shortTitle ??
      reason.title ??
      knmReasonType.title ??
      knmReasonType.shortTitle ??
      `${knmReasonType.digitCode ? `${knmReasonType.digitCode} ` : ''}${knmReasonType.name}`,
    value: knmReasonType.code,
    title: reason.title ?? knmReasonType.title ?? '',
    shortTitle: reason.shortTitle ?? knmReasonType.shortTitle ?? '',
    ervkUuid: reason.ervkUuid ?? knmReasonType.ervkUuid ?? '',
    inspectionResult,
  };
};
